import { put, call, getContext, select, cancel } from 'redux-saga/effects';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { loadTopBetsFail, loadTopBetsStart, loadTopBetsSuccess } from '../../../reducers/topBets';
import { getTopBetsRequestParams, validateTopBetsRequestParams } from './utils';
import { IAppState } from '../../../types';
import { getIsNewPublishTermsEnabled } from '../../../../utils/publishTerms';
import { IConfig } from '@cian/config/shared';
import { selectActiveServiceId } from '../../../../selectors/publishTerms';
import { getTopBets, TGetTopBetsResult } from '../../../../services/auction/getTopBets';
import { selectIsAutobrokerEnabled } from '../../../../selectors/auction';
import { selectIsAddJKState } from '../../../../selectors/jk';

export function* loadTopBets() {
  const httpApi: IHttpApi = yield getContext('httpApi');
  const logger: ILogger = yield getContext('logger');
  const config: IConfig = yield getContext('config');

  const state: IAppState = yield select();
  const selectedServiceId: ReturnType<typeof selectActiveServiceId> = yield select(selectActiveServiceId);
  const isAutobrokerEnabled: ReturnType<typeof selectIsAutobrokerEnabled> = yield select(selectIsAutobrokerEnabled);

  const { abExperiments, offer } = state;
  const { search } = window.location;

  const isAddJKState = selectIsAddJKState(state);

  const isFeatureEnabled = getIsNewPublishTermsEnabled({ search, config, abExperiments, isAddJKState });

  if (!isFeatureEnabled || !selectedServiceId || isAutobrokerEnabled) {
    yield cancel();
  }

  // Выше стоит проверка на selectedServiceId, но ТС не выводит
  const serviceId = selectedServiceId as string;

  yield put(loadTopBetsStart());

  const request = getTopBetsRequestParams({ offer, serviceId });
  const errorCode = validateTopBetsRequestParams(request);

  if (errorCode) {
    yield put(loadTopBetsFail(errorCode));
    yield cancel();
  }

  const response: TGetTopBetsResult = yield call(getTopBets, {
    httpApi,
    logger,
    parameters: request,
  });

  if (response.success) {
    yield put(loadTopBetsSuccess(response.payload));
  } else {
    yield put(loadTopBetsFail(response.payload));
  }
}
